import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TrayModule from '../TrayModule';
import Categories from '../Categories';
import Cards from './Cards';
import { getSliceCardsWithVisibility, sliceHasCategories, getSliceColourTheme } from '../../selectors';
import { cardType, colourThemeType } from '../../propTypes';
import TrayToolbar from '../TrayToolbar';
import { sliceColourTheme } from '../../styles/theme';

const ContentTray = ({
  cards,
  className,
  sliceId,
  hasCategories,
  colourTheme,
}) => (
  <TrayModule className={className} sliceId={sliceId} colourTheme={colourTheme}>
    <TrayToolbar sliceId={sliceId} colourTheme={colourTheme}>
      {hasCategories && <Categories sliceId={sliceId} colourTheme={colourTheme} />}
    </TrayToolbar>
    <Cards cards={cards} sliceId={sliceId} colourTheme={colourTheme} />
  </TrayModule>
);

ContentTray.propTypes = {
  cards: PropTypes.arrayOf(cardType).isRequired,
  className: PropTypes.string,
  sliceId: PropTypes.number.isRequired,
  hasCategories: PropTypes.bool,
  colourTheme: colourThemeType,
};

ContentTray.defaultProps = {
  className: undefined,
  hasCategories: false,
  colourTheme: sliceColourTheme.white,
};

const mapStateToProps = (state, { sliceId }) => ({
  cards: getSliceCardsWithVisibility(state, sliceId),
  hasCategories: sliceHasCategories(state, sliceId),
  colourTheme: sliceColourTheme[getSliceColourTheme(state, sliceId)],
});

export default connect(mapStateToProps)(ContentTray);
